import React, { CSSProperties, useState, useEffect } from "react";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faImage, faArrowPointer } from '@fortawesome/free-solid-svg-icons';
import { useStickerSectionStore } from "../EditorStore";
import SelectorEditor from "./SelectorEditor";
import { CanvasDrawer } from "../CanvasDrawer";
import BackgroundEditor from "./BackgroundEditor";



export default function Header() {

    const toolSelected = useStickerSectionStore((state) => state.toolSelected);
    const setToolSelected = useStickerSectionStore((state) => state.setToolSelected);
    const toolSelectedRef = useStickerSectionStore((state) => state.toolSelectedRef);
    const canvasImageSelected = useStickerSectionStore((state) => state.canvasImageSelected);
    const setCanvasImageSelected = useStickerSectionStore((state) => state.setCanvasImageSelected);
    const currentSelectedCanvasImageRef = useStickerSectionStore((state) => state.currentCanvasImageSelectedRef)
    const isPortrait = useStickerSectionStore((state) => state.isPortrait)
    const setCursorStyle = useStickerSectionStore((state) => state.setCursorStyle)

    const [showSelector, setShowSelector] = useState(false);
    const [selectorOpacity, setSelectorOpacity] = useState(0);

    const [showBackground, setShowBackground] = useState(false);
    const [backgroundOpacity, setBackgroundOpacity] = useState(0);

    useEffect(() => {
        if (canvasImageSelected) {
            setShowSelector(true);
            requestAnimationFrame(() => setSelectorOpacity(1));
        } else {
            setSelectorOpacity(0);
            const timeout = setTimeout(() => setShowSelector(false), 300);
            return () => clearTimeout(timeout);
        }
    }, [canvasImageSelected]);

    useEffect(() => {
        if (toolSelected === "background") {
            setShowBackground(true);
            requestAnimationFrame(() => requestAnimationFrame(() => setBackgroundOpacity(1)));
        } else {
            setBackgroundOpacity(0);
            const timeout = setTimeout(() => setShowBackground(false), 300);
            return () => clearTimeout(timeout);
        }
    }, [toolSelected]);

    const headerContainerStyle: React.CSSProperties = {
        height: isPortrait ? "7%" : "auto",
        width: isPortrait ? "100%" : "5%",
        display: "flex",
        flexDirection: isPortrait ? "row" : "column",
        alignItems: "center",
        justifyContent: isPortrait ? "center" : "start",
        position: "absolute",
        zIndex: "3",
        pointerEvents: "none",
        marginTop: "1vh",
        marginLeft: isPortrait ? "0" : "1vw"

    };

    const buttonContainerStyles: CSSProperties = {
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        height: "100%",
        width: "100%",
        pointerEvents: "auto"
    };

    const iconWrapperStyles = (button: string): CSSProperties => ({
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        width: "100%",
        height: "100%",
        borderRadius: "10px",
        backgroundColor:
            toolSelected === button ? "#4B5563" : "",
        transition: "background-color 0.2s ease-in-out",
        cursor: "pointer",
        textDecoration: "none",
        WebkitTapHighlightColor: "transparent",
    });

    const iconContainerStyles: CSSProperties = {
        height: "3vh",
        width: "3vh",
        cursor: "inherit",
        color: "#F9FAFB",
    };

    const setTool = (tool: string) => {

        if (tool == "pan") {
            setCursorStyle('grab')
        } else {
            setCursorStyle('default')
        }
        setToolSelected(tool);
        toolSelectedRef.current = tool;

        if (tool != "selector") {
            setCanvasImageSelected(false)
            if (currentSelectedCanvasImageRef.current) {
                currentSelectedCanvasImageRef.current.selected = false
                currentSelectedCanvasImageRef.current = null
            }

            CanvasDrawer.rerenderCanvas()
        }
    };

    return (
        <div id="header-buttons-container" style={headerContainerStyle}>
            <div
                style={{
                    display: "flex",
                    flexDirection: isPortrait ? "row" : "column",
                    justifyContent: "center",
                    alignItems: "center",
                    height: isPortrait ? "7vh" : "50vh",
                    width: isPortrait ? "75%" : "100%",
                    border: "2px solid #F9FAFB",
                    backgroundColor: "rgba(0, 0, 0, 0.7)",
                    borderRadius: "10px",

                }}
            >
                {[
                    { tool: "selector", icon: faArrowPointer },
                    { tool: "background", icon: faImage },
                ].map(({ tool, icon }) => (
                    <div key={tool} style={buttonContainerStyles} id="header-button-container">
                        <div
                            onClick={() => setTool(tool)}
                            style={iconWrapperStyles(tool)}
                        >
                            <FontAwesomeIcon style={iconContainerStyles} icon={icon} />
                        </div>
                    </div>
                ))}
            </div>

            {showSelector && (
                <div
                    style={{
                        opacity: selectorOpacity,
                        transition: "opacity 0.3s ease-in-out",
                        pointerEvents: selectorOpacity === 0 ? "none" : "auto",
                    }}
                >
                    <SelectorEditor />
                </div>
            )}

            {showBackground && (
                <div
                    style={{
                        opacity: backgroundOpacity,
                        transition: "opacity 0.3s ease-in-out",
                        pointerEvents: backgroundOpacity === 0 ? "none" : "auto",
                    }}
                >
                    <BackgroundEditor />
                </div>
            )}
        </div>
    );
}
